import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Nieuwe {{method}} bestelling!',
        scheduled: 'Geplande {{method}} bestelling!',
        on_site: 'Nieuwe tafelbestelling!',
        // Table orders are ASAP; this is for room-service orders scheduled before the rename.
        on_site_scheduled: 'Geplande tafelbestelling!',
      },
      labels: {
        today: 'vandaag',
        time_remaining_to_accept: 'resterend om te accepteren',
      },
      time_tag: {
        [OrderMethod.Pickup]: {
          asap: '🕓 Afhalen over {{time}}',
          scheduled: '🕓 Afhalen {{day}} om {{time}}',
          scheduled_today: '🕓 Afhalen vandaag om {{time}}',
        },
        [OrderMethod.Delivery]: {
          asap: '🕓 Bezorging over {{time}}',
          scheduled: '🕓 Bezorging {{day}} om {{time}}',
          scheduled_today: '🕓 Bezorging vandaag om {{time}}',
        },
        [OrderMethod.OnSite]: {
          // No 🕓: the screen draws the design's clock icon for table orders.
          asap: 'Serveren over {{from}}–{{to}} min',
          scheduled: 'Serveren {{day}} om {{time}}',
          scheduled_today: 'Serveren vandaag om {{time}}',
        },
      },
      time_tag_estimated: {
        asap: '🕓 Ruwe schatting afhalen: {{time}}',
        scheduled: '🕓 Ruwe schatting afhalen: {{day}} om {{time}}',
      },
      buttons: {
        confirm_order: 'Bestelling bevestigen',
        cancel_order: 'Bestelling annuleren',
      },
      feedback: {
        rough_estimate_warning:
          'Dit is slechts een ruwe schatting. Je ontvangt de exacte bereidingstijd zodra een bezorger is toegewezen en de levertijd is bevestigd. Op dat moment wordt je bon automatisch afgedrukt.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Bereidingstijd',
      labels: {
        today: 'vandaag',
        order_time: {
          [OrderMethod.Delivery]: {
            asap: 'Bezorging over',
            scheduled: 'Bezorging op',
            scheduled_today: 'Bezorging',
          },
          [OrderMethod.Pickup]: {
            asap: 'Afhalen over',
            scheduled: 'Afhalen op',
            scheduled_today: 'Afhalen',
          },
          [OrderMethod.OnSite]: {
            asap: 'Serveren over',
            scheduled: 'Serveren op',
            scheduled_today: 'Serveren',
          },
        },
        can_you_make_it: 'Lukt het?',
        we_also_send_this_update_to_the_customer: 'We sturen deze update ook naar de klant',
      },
      buttons: {
        yes_lets_go: 'Ja, aan de slag!',
        no_change_time: 'Nee, tijd wijzigen',
        confirm: 'Bevestigen',
      },
      toasts: {
        order_confirmed: {
          title: 'Bestelling #{{number}} bevestigd',
          body: 'Nog niet bereiden! We informeren je wanneer een bezorger is toegewezen.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Helaas moet de bezorging worden geannuleerd omdat er geen bezorger beschikbaar is. Klik op de drie puntjes rechtsboven om de bestelling te annuleren en het geld aan de klant terug te betalen.',
        [BackendErrorCode.DeliveryProviderException]:
          'Helaas moet de bezorging worden geannuleerd omdat er geen bezorger beschikbaar is. Klik op de drie puntjes rechtsboven om de bestelling te annuleren en het geld aan de klant terug te betalen.',
        [BackendErrorCode.DeliveryDispatchRetrying]:
          'Bestelling geaccepteerd, maar er is nog geen bezorger geboekt. We blijven 15 minuten proberen en melden het als er geen is.',
      },
    },
  },
  error_messages: {
    something_went_wrong: 'Er is iets misgegaan, probeer het opnieuw',
  },
};
